import appGlobalScript from '/opt/atlassian/pipelines/agent/build/node_modules/@interbank/design-system/dist/collection/global/global-script.js';
export const globalScripts = appGlobalScript;
